export default "__VITE_ASSET__gFajoZco__"